import { CaseFolderObject } from './DataAdminTypes';

export function initFileUploadState(
  file: File | null,
  index: number,
  existingFile: CaseFolderObject|null
): FileUploadState {
  return {
    attemptCount: 0,
    currentThreads: 0,
    error: null,
    endTime: null,
    estimatedSecondsRemaining: null,
    existingFile: existingFile,
    fileName: file?.name || '',
    file: file,
    index: index,
    progress: 0,
    uploadedBytes: 0,
    totalFileBytes: file?.size || 0,
    totalParts: 0,
    startTime: null,
    status: FileUploadStatus.PENDING,
  };
}

export enum FileUploadStatus {
  ABORTED = 'ABORTED',
  PENDING = 'PENDING',
  UPLOADING = 'UPLOADING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  RETRYING = 'RETRYING',
  INITIALIZING = 'INITIALIZING'
}

export interface FileUploadState {
  attemptCount: number;
  currentThreads: number;
  endTime?: number | null;
  error: string | null;
  estimatedSecondsRemaining: number | null;
  existingFile: CaseFolderObject|null;
  fileName: string | null;
  index: number;
  file: File|null;
  status: FileUploadStatus;
  progress: number;
  uploadedBytes: number;
  totalFileBytes: number;
  totalParts: number;
  startTime: number | null;
}

export interface FileUploadProps {
  caseFolder: string;
  concurrency: number;
  maxFileSize: number;
  maxRetries: number;
  allowedTypes?: string[];
  onUploadComplete: (key: string) => void;
  onUploadError: (error: Error) => void;
}
